import React from "react";
import { NavLink } from "react-router-dom";
import { Icon, Typography, theme } from "cdh-data-portal-theme";
import type { IconPathProps } from "cdh-data-portal-theme";
import { useStyles } from "./SidebarNavItem.style";

export interface SidebarNavItemProps {
  readonly className?: string;
  readonly icon: IconPathProps;
  readonly label: string;
  readonly onClick?: () => void;
  readonly url?: string;
}

export const SidebarNavItem: React.FC<SidebarNavItemProps> = ({
  className,
  icon,
  label,
  onClick,
  url,
}) => {
  const { classes, cx } = useStyles();

  return url ? (
    <NavLink
      to={url}
      end
      onClick={onClick}
      className={({ isActive }) =>
        cx(classes.root, isActive && classes.active, className)
      }
    >
      {({ isActive }) => (
        <>
          {isActive && <span className={classes.indicator} />}
          <Icon
            iconPath={icon}
            color={isActive ? theme.colors.primary : "currentColor"}
          />
          <Typography
            variant="body"
            bold
            className={classes.label}
            color={isActive ? theme.colors.primary : undefined}
          >
            {label}
          </Typography>
        </>
      )}
    </NavLink>
  ) : (
    <div
      role="button"
      tabIndex={0}
      className={cx(classes.root, className)}
      onClick={onClick}
    >
      <Icon iconPath={icon} color="currentColor" />
      <Typography variant="body" bold className={classes.label}>
        {label}
      </Typography>
    </div>
  );
};
